// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General form container */
.form-container {
    font-family: Arial, sans-serif;
    max-width: 700px;
    margin: 0 auto;
    padding: 30px;
  }
  
  /* Header */
  .form-container h1 {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  /* Required note */
  .form-container .note {
    font-size: 14px;
    margin-bottom: 20px;
  }
  
  /* Form group spacing */
  .form-group {
    margin-bottom: 25px;
  }
  
  /* Labels */
  label {
    display: block;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
  }
  
  /* Select box */
  select {
    width: 100%;
    padding: 10px 12px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  /* Input group with dollar sign */
  .input-group {
    display: flex;
    align-items: center;
  }
  
  .input-group span {
    background-color: #f5f5f5;
    padding: 10px 14px;
    border: 1px solid #ccc;
    border-right: none;
    border-radius: 4px 0 0 4px;
    font-size: 16px;
  }
  
  .input-group input {
    flex: 1 1;
    padding: 10px 14px;
    border: 1px solid #ccc;
    /* border-left: none; */
    border-radius: 0 4px 4px 0;
    font-size: 16px;
    display: block;
  }
  
  /* Radio buttons */
  .radio-group {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  .radio-group label {
    display: flex;
    align-items: center;
    padding: 15px;
    border: 1px solid #ccc;
    border-radius: 6px;
    cursor: pointer;
    transition: border-color 0.2s;
  }
  
  .radio-group input[type="radio"] {
    margin-right: 12px;
  }
  
  /* Info box */
  .info-box {
    background-color: #f0faff;
    padding: 15px 20px;
    border-left: 4px solid #4a90e2;
    border-radius: 4px;
    font-size: 14px;
  }
  
  .info-box a {
    color: #4a90e2;
    text-decoration: underline;
  }

  /* Residency options container */
.residency-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  /* Hide the default radio button but keep it interactive */
.residency-option input[type="radio"] {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }
  
  /* Ensure the entire residency option is clickable */
  .residency-option {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #f9f9f9;
    position: relative; /* Required for the hidden input */
  }
  
  .residency-option.selected {
    border-color: #007bff;
    background-color: #e9f5ff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
  
  /* Label styling */
  .residency-option label {
    margin: 0;
    font-size: 16px;
    color: #333;
    cursor: pointer;
    flex: 1 1; /* Makes the label take up the full width of the option */
  }
  
  /* Hover effect */
  .residency-option:hover {
    border-color: #007bff;
    background-color: #f0f8ff;
  }
/* Submit button styling */
button[type="submit"] {
    display: block;
    width: 100%;
    padding: 12px 20px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #2895eb;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
  }
  
  button[type="submit"]:hover {
    background-color: #0056b3;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  
  button[type="submit"]:active {
    background-color: #004494;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
  
  button[type="submit"]:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    box-shadow: none;
  }

.loader {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #3498db;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 20px auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.tax-results {
  background-color: #f8f9fa;
  margin-top: 20px;
}

.results-section {
  min-height: 100px;
}

.loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
  }
  
  .spinner {
    width: 24px;
    height: 24px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-right: 10px;
  }
  
  /* Keyframes for spinner animation */
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  .error {
    background-color: #ffebee;
    color: #c62828;
    padding: 1rem;
    margin: 1rem 0;
    border-radius: 4px;
    border: 1px solid #ef9a9a;
  }
  
  .result-container {
    background-color: #e8f5e9;
    padding: 1rem;
    margin: 1rem 0;
    border-radius: 4px;
    border: 1px solid #a5d6a7;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/agent/taxwithheldcalculator.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;IACd,aAAa;EACf;;EAEA,WAAW;EACX;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA,uBAAuB;EACvB;IACE,mBAAmB;EACrB;;EAEA,WAAW;EACX;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,eAAe;EACf;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,iCAAiC;EACjC;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,eAAe;IACf,cAAc;EAChB;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;EACpB;;EAEA,aAAa;EACb;IACE,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA,gCAAgC;AAClC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,0DAA0D;AAC5D;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;EACtB;;EAEA,oDAAoD;EACpD;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB,EAAE,kCAAkC;EACxD;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,0CAA0C;EAC5C;;EAEA,kBAAkB;EAClB;IACE,SAAS;IACT,eAAe;IACf,WAAW;IACX,eAAe;IACf,SAAO,EAAE,yDAAyD;EACpE;;EAEA,iBAAiB;EACjB;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;AACF,0BAA0B;AAC1B;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,4DAA4D;EAC9D;;EAEA;IACE,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;EAClB;;AAEF;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA,oCAAoC;EACpC;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yBAAyB;EAC3B","sourcesContent":["/* General form container */\n.form-container {\n    font-family: Arial, sans-serif;\n    max-width: 700px;\n    margin: 0 auto;\n    padding: 30px;\n  }\n  \n  /* Header */\n  .form-container h1 {\n    font-size: 32px;\n    font-weight: bold;\n    margin-bottom: 10px;\n  }\n  \n  /* Required note */\n  .form-container .note {\n    font-size: 14px;\n    margin-bottom: 20px;\n  }\n  \n  /* Form group spacing */\n  .form-group {\n    margin-bottom: 25px;\n  }\n  \n  /* Labels */\n  label {\n    display: block;\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 8px;\n  }\n  \n  /* Select box */\n  select {\n    width: 100%;\n    padding: 10px 12px;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  }\n  \n  /* Input group with dollar sign */\n  .input-group {\n    display: flex;\n    align-items: center;\n  }\n  \n  .input-group span {\n    background-color: #f5f5f5;\n    padding: 10px 14px;\n    border: 1px solid #ccc;\n    border-right: none;\n    border-radius: 4px 0 0 4px;\n    font-size: 16px;\n  }\n  \n  .input-group input {\n    flex: 1;\n    padding: 10px 14px;\n    border: 1px solid #ccc;\n    /* border-left: none; */\n    border-radius: 0 4px 4px 0;\n    font-size: 16px;\n    display: block;\n  }\n  \n  /* Radio buttons */\n  .radio-group {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .radio-group label {\n    display: flex;\n    align-items: center;\n    padding: 15px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: border-color 0.2s;\n  }\n  \n  .radio-group input[type=\"radio\"] {\n    margin-right: 12px;\n  }\n  \n  /* Info box */\n  .info-box {\n    background-color: #f0faff;\n    padding: 15px 20px;\n    border-left: 4px solid #4a90e2;\n    border-radius: 4px;\n    font-size: 14px;\n  }\n  \n  .info-box a {\n    color: #4a90e2;\n    text-decoration: underline;\n  }\n\n  /* Residency options container */\n.residency-options {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  /* Hide the default radio button but keep it interactive */\n.residency-option input[type=\"radio\"] {\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n  }\n  \n  /* Ensure the entire residency option is clickable */\n  .residency-option {\n    display: flex;\n    align-items: center;\n    padding: 10px 15px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    background-color: #f9f9f9;\n    position: relative; /* Required for the hidden input */\n  }\n  \n  .residency-option.selected {\n    border-color: #007bff;\n    background-color: #e9f5ff;\n    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n  }\n  \n  /* Label styling */\n  .residency-option label {\n    margin: 0;\n    font-size: 16px;\n    color: #333;\n    cursor: pointer;\n    flex: 1; /* Makes the label take up the full width of the option */\n  }\n  \n  /* Hover effect */\n  .residency-option:hover {\n    border-color: #007bff;\n    background-color: #f0f8ff;\n  }\n/* Submit button styling */\nbutton[type=\"submit\"] {\n    display: block;\n    width: 100%;\n    padding: 12px 20px;\n    font-size: 16px;\n    font-weight: bold;\n    color: #fff;\n    background-color: #2895eb;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  button[type=\"submit\"]:hover {\n    background-color: #0056b3;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  }\n  \n  button[type=\"submit\"]:active {\n    background-color: #004494;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  }\n  \n  button[type=\"submit\"]:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n    box-shadow: none;\n  }\n\n.loader {\n  border: 4px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 4px solid #3498db;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin: 20px auto;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.tax-results {\n  background-color: #f8f9fa;\n  margin-top: 20px;\n}\n\n.results-section {\n  min-height: 100px;\n}\n\n.loading-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1rem;\n  }\n  \n  .spinner {\n    width: 24px;\n    height: 24px;\n    border: 3px solid #f3f3f3;\n    border-top: 3px solid #3498db;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin-right: 10px;\n  }\n  \n  /* Keyframes for spinner animation */\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  \n  .error {\n    background-color: #ffebee;\n    color: #c62828;\n    padding: 1rem;\n    margin: 1rem 0;\n    border-radius: 4px;\n    border: 1px solid #ef9a9a;\n  }\n  \n  .result-container {\n    background-color: #e8f5e9;\n    padding: 1rem;\n    margin: 1rem 0;\n    border-radius: 4px;\n    border: 1px solid #a5d6a7;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
